import { localStorage } from "../../pages/customizer/__constant";
import $ from "jquery";
import { LocalStorage } from "storage-manager-js";

const ajaxSaveWishlist = (buttonSelector, isSingle = false) => {
  $(document).on("click", buttonSelector, function () {
    const isLoggedIn = $(this).data("is_logged_in");
    const thisEl = $(this);
    if (!isLoggedIn) {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = $(this).data("action"); // Replace with the actual URL

      const data = document.createElement("input");
      data.type = "hidden";
      data.name = "data";
      data.value = isSingle ? "" : LocalStorage.get(localStorage.customizer);
      form.appendChild(data);

      const data_popup = document.createElement("input");
      data_popup.type = "hidden";
      data_popup.name = "data_popup";
      data_popup.value = $(this).find("input").val();
      form.appendChild(data_popup);

      document.body.appendChild(form);
      form.submit();
    } else {
      $("body").addClass("mi-loading");
      $.ajax({
        type: "POST",
        dataType: "json",
        url: $(this).data("action"),
        data: {
          action: $(this).data("form_action"),
          nonce: $(this).data("nonce"),
          data: isSingle ? "" : LocalStorage.get(localStorage.customizer),
          data_popup: $(this).find("input").val(),
        },
        success: function (response) {
          $("body").removeClass("mi-loading");
          if (response.success) {
            thisEl.addClass("saved");
          }
        },
        error: (err) => {
          $("body").removeClass("mi-loading");
          console.error(err);
        },
      });
    }
  });
};

export default ajaxSaveWishlist;
